import { apiPost } from "../shared/apiClient";

export function queryHistoryIdentity(chat) {
  return { whatsappId: chat?.phone || "", contactId: chat?.contactId || null, bsuid: chat?.bsuid || null };
}
export function activityLabel(activity) {
  return activity?.available ? `${activity.today_count}/${activity.all_time_count}` : "—";
}
export function matchesActivity(chat, filter) {
  if (filter === "all") return true;
  return !!chat.query_activity?.available && (filter === "queried_today"
    ? chat.query_activity.today_count > 0 : chat.query_activity.today_count === 0);
}
// Provider exposes named filters without a documented stable ID mapping.
// Match exact normalized names, never indices or guessed filterType values.
export function canLoadAllFilter(filter) {
  return ["active chats", "unread", "assigned to me", "unassigned", "open", "pending", "solved"]
    .includes((filter?.name || "").trim().toLowerCase());
}
export async function fetchQueryHistory(chat, cursor = null, signal) {
  const res = await apiPost("/wati_messages/get_chat_query_history", {
    ...queryHistoryIdentity(chat), page_size: 10, cursor,
  }, { signal });
  if (!res.data?.success) throw new Error(res.data?.message || "Unable to load query history");
  return res.data.data;
}
